import { defaultTheme } from '../../theming/data/defaultTheme'
import fonts from '../../tokens/fonts'
import styled from 'styled-components'
import { composeTheme } from '../../utils/compose-theme'

export const Label = styled.label.attrs((props) => composeTheme(props))`
  color: ${(props) => props.theme.inputLabel.color};
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.inputLabel.fontSize};
  font-weight: ${(props) => props.theme.inputLabel.fontWeight};
  line-height: ${(props) => props.theme.inputLabel.fontHeight};
  margin-bottom: ${(props) => props.theme.inputLabel.marginBottom};
  position: static;
  transform: none;
  transform-origin: unset;
`
Label.defaultProps = defaultTheme
